import { setUserLocale } from './locale';
import { Locale } from '@/shared/i18n/config';

// 공통 언어 변경 핸들러
export const handleLanguageChange = (value: string, onClose?: () => void) => {
    setUserLocale(value as Locale);
    onClose?.();
}; 